module.exports = __webpack_public_path__ + "static/img/促销背景@3x.c73eb73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/促销背景@3x.png
// module id = Jsfm
// module chunks = 192